import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { viewerDisabledProps } from "../utils/permissions";

const EditAttendance = () => {
  const navigate = useNavigate();
  const { date, kithcheniddd, id } = useParams();

  const [entryDate, setEntryDate] = useState(date); // From URL
  const [entryTimeOnly, setEntryTimeOnly] = useState("");
  const [exitTimeOnly, setExitTimeOnly] = useState("");
  const [entryFile, setEntryFile] = useState(null);
  const [exitFile, setExitFile] = useState(null);
  const [errors, setErrors] = useState({});

  const formatDateTimeFromParts = (datePart, timePart) => {
    return `${datePart} ${timePart}:00`; // "YYYY-MM-DD HH:MM:00"
  };

  useEffect(() => {
    const fetchAttendance = async () => {
      try {
        const res = await axios.get(
          `https://ims-attendanceback.indevconsultancy.in/api/attendance-detail-master/?employee_id=${id}`
        );

        const filtered = res.data.find((item) => {
          if (!item.entry_time) return false;
          const entryDate = new Date(item.entry_time);
          const entryLocalDate = entryDate.toLocaleDateString("en-CA");
          return entryLocalDate === date;
        });

        if (filtered) {
          if (filtered.entry_time) {
            const entry = new Date(filtered.entry_time);
            setEntryTimeOnly(entry.toTimeString().slice(0, 5)); // "HH:MM"
          }
          if (filtered.exit_time) {
            const exit = new Date(filtered.exit_time);
            setExitTimeOnly(exit.toTimeString().slice(0, 5));
          }
        }
      } catch (err) {
        console.error("Failed to fetch attendance:", err);
      }
    };

    fetchAttendance();
  }, [date, id]);

  const validateImage = (file) => {
    const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
    const maxSize = 2 * 1024 * 1024; // 2MB

    if (!allowedTypes.includes(file.type)) {
      return "Only JPG and PNG files are allowed.";
    }

    if (file.size > maxSize) {
      return "Image size should not exceed 2MB.";
    }

    return null;
  };

  const handleSubmitEntry = async () => {
    let validationErrors = {};

    if (!entryTimeOnly) {
      validationErrors.entryTime = "Entry time is required.";
    }

    // if (entryFile) {
    //   const fileError = validateImage(entryFile);
    //   if (fileError) {
    //     validationErrors.entryFile = fileError;
    //   }
    // }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const formData = new FormData();
    formData.append("user_id", id);
    formData.append("kitcehenid", kithcheniddd); // spelling from backend
    formData.append("entry_time", formatDateTimeFromParts(entryDate, entryTimeOnly));
    // Backend server-time use karta hai by default; admin ka manual time tabhi
    // accept hota hai jab edited_by (admin userid) verify ho jaye.
    formData.append("edited_by", localStorage.getItem("user_id") || "");
    formData.append("latitude", 28.5364648);
    formData.append("longitude", 77.2710271);
    // if (entryFile) {
      formData.append("filename", entryFile ?? '');
    // }

    try {
      await axios.post(
        "https://ims-attendanceback.indevconsultancy.in/api/attendance-submit/",
        formData
      );
      navigate(`/employeeList`);
    } catch (error) {
      alert("Error submitting entry.");
      console.error(error);
    }
  };

  const handleSubmitExit = async () => {
    let validationErrors = {};

    if (!exitTimeOnly) {
      validationErrors.exitTime = "Exit time is required.";
    }

    // if (exitFile) {
    //   const fileError = validateImage(exitFile);
    //   if (fileError) {
    //     validationErrors.exitFile = fileError;
    //   }
    // }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const formData = new FormData();
    formData.append("user_id", id);
    formData.append("exit_time", formatDateTimeFromParts(entryDate, exitTimeOnly));
    formData.append("edited_by", localStorage.getItem("user_id") || "");
    formData.append("latitude_exit", 28.5481533);
    formData.append("longitudeexit", 77.2828857);
    // if (exitFile) {
      formData.append("filename", exitFile ?? '');
    // }

    try {
      await axios.post(
        "https://ims-attendanceback.indevconsultancy.in/api/exit-submit/",
        formData
      );
      navigate(`/employeeList`);
    } catch (error) {
      alert("Error submitting exit.");
      console.error(error);
    }
  };

  return (
    <div className="container mt-5">
      <h3>Edit Attendance {entryDate}</h3>

      <div className="mb-3">
        <label>Entry Time</label>
        <input type="date" className="form-control" value={entryDate} disabled />

        <input
          type="time"
          className="form-control mt-2"
          value={entryTimeOnly}
          onChange={(e) => setEntryTimeOnly(e.target.value)}
        />
        {errors.entryTime && (
          <small className="text-danger">{errors.entryTime}</small>
        )}

        {/* <input
          type="file"
          accept="image/*"
          className="form-control mt-2"
          onChange={(e) => setEntryFile(e.target.files[0])}
        />
        {errors.entryFile && (
          <small className="text-danger">{errors.entryFile}</small>
        )} */}

        <small className="form-text text-muted">Image upload is optional</small>
        <button className="btn btn-primary mt-2" onClick={handleSubmitEntry} {...viewerDisabledProps()}>
          Submit Entry
        </button>
      </div>

      <div className="mb-3">
        <label>Exit Time</label>
        <input type="date" className="form-control" value={entryDate} disabled />

        <input
          type="time"
          className="form-control mt-2"
          value={exitTimeOnly}
          onChange={(e) => setExitTimeOnly(e.target.value)}
        />
        {errors.exitTime && (
          <small className="text-danger">{errors.exitTime}</small>
        )}

        {/* <input
          type="file"
          accept="image/*"
          className="form-control mt-2"
          onChange={(e) => setExitFile(e.target.files[0])}
        />
        {errors.exitFile && (
          <small className="text-danger">{errors.exitFile}</small>
        )} */}

        <small className="form-text text-muted">Image upload is optional</small>
        <button className="btn btn-success mt-2" onClick={handleSubmitExit} {...viewerDisabledProps()}>
          Submit Exit
        </button>
      </div>
    </div>
  );
};

export default EditAttendance;
